import { render } from "./RoomManager.vue?vue&type=template&id=2b780af8&scoped=true"
import script from "./RoomManager.vue?vue&type=script&lang=js"
export * from "./RoomManager.vue?vue&type=script&lang=js"

import "./RoomManager.vue?vue&type=style&index=0&id=2b780af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b780af8"]])

export default __exports__